import { Card, EmptyState, SkeletonText } from '@ashniva/ui';
import { Link, useSearchParams } from 'react-router';

import { formatDateTime } from '../../../shared/lib/format';
import { useQuestionsQuery } from '../api-questions';
import { QUESTION_STATUS_LABELS } from '../ri-text';
import { useWorkspace } from '../workspace-context';
import { ProblemNotice } from './ProblemNotice';

/** The person's own earlier questions about this repository, newest first: only they can see them. */
export function RecentQuestions({ current }: { current: string | null }) {
  const { linkId } = useWorkspace();
  const [params] = useSearchParams();
  const list = useQuestionsQuery(linkId, true);
  const hrefFor = (id: string) => {
    const next = new URLSearchParams(params);
    next.set('question', id);
    return `?${next.toString()}`;
  };
  return (
    <Card title="Your recent questions">
      {list.isLoading ? (
        <div aria-busy="true">
          <span className="sr-only">Loading your questions</span>
          <SkeletonText lines={3} />
        </div>
      ) : null}
      {list.isError ? (
        <ProblemNotice error={list.error} onRetry={() => void list.refetch()} size="sm" />
      ) : null}
      {list.isSuccess && list.data.items.length === 0 ? (
        <EmptyState size="sm" icon="○" title="You have not asked about this repository yet" />
      ) : null}
      {list.isSuccess && list.data.items.length > 0 ? (
        <ul className="ri-list">
          {list.data.items.map((item) => (
            <li key={item.id}>
              <Link
                className="ri-file-link"
                to={hrefFor(item.id)}
                aria-current={item.id === current ? 'true' : undefined}
              >
                {item.questionPreview}
              </Link>
              <div className="ri-muted">
                {QUESTION_STATUS_LABELS[item.status]} · {formatDateTime(item.createdAt)}
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </Card>
  );
}
